<template>
  <Card>
    <template slot="title">
      <Breadcrumb>
        <BreadcrumbItem to="/sys/sql">系统管理</BreadcrumbItem>
        <BreadcrumbItem>sql查询</BreadcrumbItem>
      </Breadcrumb>
    </template>
    <router-link to="/sys/sql" slot="extra">返回</router-link>
    <Form
      :model="formItem"
      :label-width="140"
      ref="formValidate"
      :rules="ruleInline"
    >
      <FormItem label="sql" prop="jobContent">
        <textarea ref="mycode" v-model="code" placeholder="按Ctrl键进行代码提示" class="codesql"
                  style="height:300px;width:600px;"/>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="save('formValidate')">保存</Button>
        <Button style="margin-left: 8px" @click="cancel('formValidate')">取消</Button>
      </FormItem>
    </Form>
  </Card>
</template>
<script>
  import 'codemirror/theme/ambiance.css'
  import 'codemirror/lib/codemirror.css'
  import 'codemirror/addon/hint/show-hint.css'

  const CodeMirror = require('codemirror/lib/codemirror')
  require('codemirror/addon/edit/matchbrackets')
  require('codemirror/addon/selection/active-line')
  require('codemirror/mode/sql/sql')
  require('codemirror/addon/hint/show-hint')
  require('codemirror/addon/hint/sql-hint')
  import sqlFormatter from 'sql-formatter';

  export default {
    data() {
      return {
        ruleInline: {
          jobContent: [
            {required: true, message: '请输入任务信息'}
          ],
        },
        formItem: {
          code: ""
        }
      };
    },
    computed: {},
    watch: {},
    components: {},
    created() {
    },
    mounted() {
      const mime = 'text/x-mariadb'
      // let theme = 'ambiance'//设置主题，不设置的会使用默认主题
      this.editor = CodeMirror.fromTextArea(this.$refs.mycode, {
        mode: mime, // 选择对应代码编辑器的语言，我这边选的是数据库，根据个人情况自行设置即可
        indentWithTabs: true,
        smartIndent: true,
        lineNumbers: true,
        matchBrackets: true,
        // theme: 'base16-light',
        // autofocus: true,
        extraKeys: {'Ctrl': 'autocomplete'}, // 自定义快捷键
        hintOptions: {// 自定义提示选项
          tables: {}
        }
      })
      this.editor.on('cursorActivity', () => {
        this.editor.showHint()
      });
    },
    methods: {
      format() {
        /* 获取文本编辑器内容*/
        let sqlContent = ''
        sqlContent = this.editor.getValue()
        /* 将sql内容进行格式后放入编辑器中*/
        this.editor.setValue(sqlFormatter.format(sqlContent))
      },
      save(name) {
        this.$refs[name].validate(valid => {
          if (valid) {
          }
        });
      },
      cancel(name) {
        this.$router.back()
      },
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/sys/sql.vue